// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__8HMYI","selects":"Documents_selects__IarW6"};